import jump from 'jump.js';

class Component {

    constructor(element) {
        // component configuration
        this.config = {
            fixedClass: 'is-fixed',
            openedClass: 'is-opened'
        };

        // component properties
        this.root = element;
        this.buttonOpen = element.querySelector('[data-toc-open]');
        this.buttonClose = element.querySelector('[data-toc-close]');
        this.panel = element.querySelector('[data-toc-panel]');
        this.anchors = element.querySelectorAll('a[href^="#"]');
        this.sections = [].slice.call(document.querySelectorAll('[data-toc-section]'));
        this.fixedHeaderHeight = document.querySelector('[data-toc-fixed-header]').offsetHeight;
        this.isTocAboveViewport = false;

        // cache initial height, fixes flicker when changing to fixed
        // as when it's fixed the panel height changes
        this.panelHeight = this.panel.offsetHeight;

        // bind to events
        window.addEventListener('scroll', event => this.onScroll(event));
        this.buttonOpen.addEventListener('click', event => this.open(event));
        this.buttonClose.addEventListener('click', event => this.close(event));
        this.root.addEventListener('click', event => this.onRootClick(event));
        this.anchors.forEach(anchor => anchor.addEventListener('click', event => this.scrollToTarget(event)));
    }

    onScroll() {
        this.isTocAboveViewport = Math.floor(this.root.getBoundingClientRect().bottom) <= this.fixedHeaderHeight;

        if (this.isTocAboveViewport) {
            // set fixed height on root element to avoid content moving up,
            // when the toc panel is set to `position: fixed`
            this.root.style.height = this.panelHeight + 'px';
            // set to display block, fixes issue where content jumps 6px~ when toggling fixed class on `[data-top-panel]`
            this.root.style.display = 'block';
            // make toc panel `position:fixed`
            this.panel.classList.add(this.config.fixedClass);
        } else {
            this.panel.classList.remove(this.config.fixedClass);
            // restore to `height: auto`
            this.root.style.height = '';
            this.root.style.display = '';
            // close sidebar panel (hide floating button)
            this.close();
        }
    }

    onRootClick(event) {
        const isOpened = this.panel.classList.contains(this.config.openedClass);
        const isBackgroundClicked = event.target === this.panel;

        if (isOpened && isBackgroundClicked) {
            this.close();
        }
    }

    open() {
        this.panel.classList.add(this.config.openedClass);
        this.buttonClose.focus();
    }

    close() {
        this.panel.classList.remove(this.config.openedClass);
        this.buttonOpen.focus();
    }

    scrollToTarget(event) {
        event.preventDefault();

        this.close();

        const href = event.target.href;
        const hash = href.slice(href.indexOf('#'));

        jump(hash); // smooth scroll to section
        window.location.hash = hash; // keep links shareable
    }
}

const enhanceElement = (element) =>
    element ? new Component(element) : false;

const enhance = () =>
    enhanceElement(document.querySelector('[data-toc]'));

export default {enhance};
